<script setup lang="ts">
import { useRouter } from 'vue-router';
import { IonIcon } from '@ionic/vue';
import { chevronBackOutline } from 'ionicons/icons';
import { PropType } from 'vue';

const props = defineProps({
	icon: { type: String, default: '' },
	to: { type: String, default: '' },
	iconClass: { type: String, default: 'text-white' },
	onClick: { type: Function as PropType<(() => void) | undefined> },
});

const router = useRouter();

const handleClick = () => {
	if (props.onClick) {
		props.onClick();
	} else if (props.to) {
		router.push(props.to);
	} else {
		router.back();
	}
};
</script>

<template>
	<div class="back-button flex items-center justify-center cursor-pointer" @click="handleClick">
		<div class="back-button-circle">
			<ion-icon :icon="icon || chevronBackOutline" class="back-icon text-[20px]"></ion-icon>
		</div>
	</div>
</template>

<style lang="scss" scoped>
.back-button {
	min-width: 44px;
	min-height: 44px;
	padding: 8px;
	margin: -8px;
}

.back-button-circle {
	width: 32px;
	height: 32px;
	border-radius: 50%;
	background: #ffffff;
	display: flex;
	align-items: center;
	justify-content: center;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

.back-icon {
	color: #000000 !important;
	margin-left: -2px;
}
</style>
